export default __webpack_public_path__ + "static/property4-ffc95b313b1d1e3cc71afd9feee12ccd.png";